import { HostBinding, Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';

import { DadosInscricao } from './shared/DadosInscricao';
import { FluxoInscricaoService } from './shared/fluxoInscricao.service';
import { ModalService } from 'app/shared/modal/modal.service';
import { routerTransition  } from 'app/shared/animations/router-transition.animation';
import { trigger, state, transition, style, animate   } from '@angular/animations';
import { environment } from 'environments/environment';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './inscricao.component.html',
  styleUrls: ['./inscricao.component.scss'],
  animations: [
    routerTransition,
    trigger('simpleFadeAnimation', [

    // the "in" style determines the "resting" state of the element when it is visible.
    state('in', style({opacity: 1})),

    // fade in when created. this could also be written as transition('void => *')
    transition(':enter', [
      style({opacity: 0}),
      animate(600 ),
    ]),

    // fade out when destroyed. this could also be written as transition('void => *')
    transition(':leave',
      animate(600, style({opacity: 0}))),
  ])],
  providers: [FluxoInscricaoService],
})
export class InscricaoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  inscricao: any = {};
  dadosInscricao: DadosInscricao;
  resumoFluxo: any[] = [];
  loadingInicial = true;

  routerSubscription: Subscription;
  dadosInscricaoSubscription: Subscription;
  resumoFluxoSubscription: Subscription;
  flagPosGraduacao: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoInscricaoService: FluxoInscricaoService,
    private modalService: ModalService,
    private notificationsService: NotificationsService,
  ) {
    this.routerSubscription = this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((evento: NavigationEnd) => {
          const path = evento.url.split('/');
          if (!this.dadosInscricao) {
            return;
          }
          const currentRoute = path[3];
          if (!this.fluxoInscricaoService.validarRotaAtual(currentRoute) &&
            !this.fluxoInscricaoService.passoAtualRetornavel()) {
            this.notificationsService.error('Ação não permitida!',
              'Para completar a inscrição você precisa passar por cada etapa na ordem estabelecida.');
            const proximaRota = this.fluxoInscricaoService.proximaRota();
            this.router.navigate([proximaRota], { relativeTo: this.route });
          } else {
            this.fluxoInscricaoService.atualizarPassoPorRota(currentRoute);
          }
      });
  }

  ngOnInit() {
    this.flagPosGraduacao = environment.flagPosGraduacao;
    if (this.flagPosGraduacao === 'false') {
      return this.router.navigate(['/']);
    }
    this.route.params.subscribe(params => {

      this.fluxoInscricaoService.setDadosInscricao({});

      this.initSubscriptions();
      this.loadingInicial = false;

      const proximaRota = this.fluxoInscricaoService.proximaRota();
      this.router.navigate([proximaRota],
        {
          relativeTo: this.route,
          queryParamsHandling: 'preserve',
        });

    });
  }


  initSubscriptions() {
    this.dadosInscricao = this.fluxoInscricaoService.getDadosInscricao();
    this.resumoFluxo = this.fluxoInscricaoService.getResumoFluxo();

    this.dadosInscricaoSubscription = this.fluxoInscricaoService.dadosInscricaoMessage$.subscribe(dadosInscricao => {
      this.dadosInscricao = dadosInscricao;
    });
    this.resumoFluxoSubscription = this.fluxoInscricaoService.resumoFluxoMessage$.subscribe(resumoFluxo => {
      this.resumoFluxo = resumoFluxo;
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.dadosInscricaoSubscription) {
      this.dadosInscricaoSubscription.unsubscribe();
    }
    if (this.resumoFluxoSubscription) {
      this.resumoFluxoSubscription.unsubscribe();
    }
  }

  mostrarModal(id: string): void {
    this.modalService.open(id);
  }

}
